export function Logo({ light = false, size = "md", showTagline = true, align = "left" }) {
  const nameCls = size === "lg" ? "text-2xl sm:text-3xl" : size === "sm" ? "text-lg" : "text-xl";
  const tagCls = size === "lg" ? "text-xs" : "text-[10px]";
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col leading-none ${alignCls}`} data-testid="brand-logo">
      <span className={`font-head font-extrabold tracking-tight ${nameCls} ${light ? "text-white" : "text-slate-900"}`}>
        GDIOT PAY
      </span>
      {showTagline && (
        <span className={`font-semibold mt-1 tracking-wide ${tagCls} ${light ? "text-blue-300" : "text-blue-600"}`}>
          Fast and Secure
        </span>
      )}
    </div>
  );
}
